import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { MapPin, Phone, Facebook, Clock } from 'lucide-react';
export function Contact() {
  useDocumentMeta('Contact Kjergaard Sports | Lake Benton, Minnesota', 'Contact Kjergaard Sports in Lake Benton, Minnesota. Get directions, call the store, or check our Facebook page for hours and updates.');
  return <div data-id="element-176">
      <PageHero title="Contact Kjergaard Sports" image="https://cdn.magicpatterns.com/uploads/f5Jp1yjaV9t3nwDxVsC5wU/exterior-front-building.jpg" alt="Kjergaard Sports storefront in Lake Benton, Minnesota" data-id="element-177" />

      <section className="py-20 bg-brand-offwhite" data-id="element-178">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-179">
          <div className="bg-brand-bone rounded-sm overflow-hidden shadow-sm border border-brand-cream" data-id="element-180">
            <div className="grid lg:grid-cols-2" data-id="element-181">
              {/* Contact Info */}
              <div className="p-10 lg:p-16" data-id="element-182">
                <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-8" data-id="element-183">
                  Visit Us in Lake Benton
                </h2>

                <div className="space-y-8 mb-10" data-id="element-184">
                  <div className="flex items-start" data-id="element-185">
                    <MapPin className="w-6 h-6 text-brand-hunter mr-4 mt-1 flex-shrink-0" data-id="element-186" />
                    <div data-id="element-187">
                      <h3 className="font-medium text-brand-charcoal text-lg mb-1" data-id="element-188">
                        Address
                      </h3>
                      <p className="text-brand-charcoal/80" data-id="element-189">
                        Kjergaard Sports
                        <br data-id="element-190" />
                        1951 200th Avenue
                        <br data-id="element-191" />
                        Lake Benton, Minnesota 56149
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start" data-id="element-192">
                    <Phone className="w-6 h-6 text-brand-hunter mr-4 mt-1 flex-shrink-0" data-id="element-193" />
                    <div data-id="element-194">
                      <h3 className="font-medium text-brand-charcoal text-lg mb-1" data-id="element-195">
                        Phone
                      </h3>
                      <a href="tel:507-368-4696" className="text-brand-hunter hover:text-brand-wood font-medium text-lg transition-colors" data-id="element-196">
                        507-368-4696
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start" data-id="element-197">
                    <Clock className="w-6 h-6 text-brand-hunter mr-4 mt-1 flex-shrink-0" data-id="element-198" />
                    <div data-id="element-199">
                      <h3 className="font-medium text-brand-charcoal text-lg mb-1" data-id="element-200">
                        Hours & Updates
                      </h3>
                      <p className="text-brand-charcoal/80" data-id="element-201">
                        Please call or check Facebook for current hours, class
                        dates, and store updates.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex flex-wrap gap-4 mb-12" data-id="element-202">
                  <a href="tel:507-368-4696" className="bg-brand-hunter hover:bg-brand-wood text-brand-offwhite px-6 py-3 rounded-sm font-medium transition-colors flex items-center" data-id="element-203">
                    <Phone className="w-4 h-4 mr-2" data-id="element-204" />
                    Call the Store
                  </a>
                  <a href="https://maps.google.com/?q=1951+200th+Avenue+Lake+Benton+Minnesota+56149" target="_blank" rel="noopener noreferrer" className="border border-brand-hunter text-brand-hunter hover:bg-brand-hunter hover:text-brand-offwhite px-6 py-3 rounded-sm font-medium transition-colors flex items-center" data-id="element-205">
                    <MapPin className="w-4 h-4 mr-2" data-id="element-206" />
                    Get Directions
                  </a>
                  <a href="https://www.facebook.com/profile.php?id=100057537217940" target="_blank" rel="noopener noreferrer" className="bg-[#1877F2] hover:bg-[#0c5dc7] text-white px-6 py-3 rounded-sm font-medium transition-colors flex items-center" data-id="element-207">
                    <Facebook className="w-4 h-4 mr-2" data-id="element-208" />
                    Follow on Facebook
                  </a>
                </div>

                {/* Simple Contact Form Placeholder */}
                <div className="pt-8 border-t border-brand-cream" data-id="element-209">
                  <h3 className="text-xl font-serif text-brand-charcoal mb-4" data-id="element-210">
                    Send a Message
                  </h3>
                  <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-211">
                    <div data-id="element-212">
                      <label className="block text-sm font-medium text-brand-charcoal mb-1" data-id="element-213">
                        Name
                      </label>
                      <input type="text" className="w-full px-4 py-2 rounded-sm border border-brand-cream bg-brand-offwhite focus:outline-none focus:border-brand-hunter" data-id="element-214" />
                    </div>
                    <div data-id="element-215">
                      <label className="block text-sm font-medium text-brand-charcoal mb-1" data-id="element-216">
                        Phone or Email
                      </label>
                      <input type="text" className="w-full px-4 py-2 rounded-sm border border-brand-cream bg-brand-offwhite focus:outline-none focus:border-brand-hunter" data-id="element-217" />
                    </div>
                    <div data-id="element-218">
                      <label className="block text-sm font-medium text-brand-charcoal mb-1" data-id="element-219">
                        Message
                      </label>
                      <textarea rows={4} className="w-full px-4 py-2 rounded-sm border border-brand-cream bg-brand-offwhite focus:outline-none focus:border-brand-hunter" data-id="element-220"></textarea>
                    </div>
                    <button type="button" className="bg-brand-charcoal hover:bg-brand-hunter text-brand-offwhite px-6 py-2 rounded-sm font-medium transition-colors" data-id="element-221">
                      Submit
                    </button>
                  </form>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="bg-brand-cream relative min-h-[400px] flex items-center justify-center p-8 border-l border-brand-cream" data-id="element-222">
                <div className="absolute inset-0 opacity-10 bg-[url('https://cdn.magicpatterns.com/uploads/f5Jp1yjaV9t3nwDxVsC5wU/exterior-front-building.jpg')] bg-cover bg-center" data-id="element-223"></div>
                <div className="relative z-10 text-center bg-brand-offwhite/90 backdrop-blur-sm p-8 rounded-sm shadow-sm border border-brand-bone max-w-sm" data-id="element-224">
                  <MapPin className="w-12 h-12 text-brand-hunter mx-auto mb-4" data-id="element-225" />
                  <h3 className="text-xl font-serif text-brand-charcoal mb-2" data-id="element-226">
                    Find Us in Lake Benton
                  </h3>
                  <p className="text-brand-charcoal/70 mb-6" data-id="element-227">
                    Located in rural Minnesota, offering a massive selection
                    worth the drive.
                  </p>
                  <a href="https://maps.google.com/?q=1951+200th+Avenue+Lake+Benton+Minnesota+56149" target="_blank" rel="noopener noreferrer" className="inline-block bg-brand-hunter text-brand-offwhite px-6 py-2 rounded-sm font-medium hover:bg-brand-wood transition-colors" data-id="element-228">
                    View on Google Maps
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}